import React, { ReactNode } from "react";
import _ from "lodash";
import { withLayout } from "../../components/layout/Layout";
import { withPageName } from "../../components/layout/horizontalMenu/PageName";

interface SettingsContentProps {
  children: ReactNode;
}

function SettingsContentComponent({ children }: SettingsContentProps) {
  return <div className="settings-page">{children}</div>;
}

export const SettingsContent = _.flowRight(
  withLayout(),
  withPageName()
)(SettingsContentComponent);
